import { render, staticRenderFns } from "./learnerpractice.vue?vue&type=template&id=1a47b10c&scoped=true&"
import script from "./learnerpractice.vue?vue&type=script&lang=ts&"
export * from "./learnerpractice.vue?vue&type=script&lang=ts&"
import style0 from "./learnerpractice.vue?vue&type=style&index=0&id=1a47b10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47b10c",
  null
  
)

export default component.exports